// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"media-slider_sliderContainer__fi7ZJ"};